import borders from './borders'
import colors from './colors'
import radius from './radius'
import shadows from './shadows'
import spacing from './spacing'
import iconsSize from './icons-size'
import fontWeights from './font-weights'
import {DeepPartial, SemanticsObject} from '../types/semantics.types'

const semanticOverrides: DeepPartial<SemanticsObject> = {
    colors: {
        text: {
            primary: colors['brand-primary'][100],
            secondary: colors['black'][60],
            disable: colors.black[30],
        },
        border: {
            default: colors.black[60],
            dark: colors.borderDark,
            inverse: colors['border-inverse'],
            secondary: colors['black'][70],
        },
        background: {
            brand: colors['brand-primary'][100],
            'off-white': colors.black[10],
            grey: colors.black[30],
            'light-blue': colors['brand-primary'][60],
            'brand-secondary-opacy': colors['brand-secondary-opacity'],
            'light-grey': colors.black[20],
            image: colors.imageBackground,
        },
        button: {
            text: {
                'primary-hover': colors['brand-primary'][100],
                'primary-disabled': colors.black[30],
                'secondary-default': colors['brand-primary'][100],
                'secondary-focused': colors['brand-primary'][100],
                'secondary-disabled': colors.black[30],
                'secondary-pressed': colors.white,
                'icon-default': colors.black[100],
                'icon-hover': colors['brand-primary'][100],
                // // inverse
                'inverse-primary-default': colors['brand-primary'][100],
                'inverse-primary-hover': colors.white,
                'inverse-primary-focused': colors['brand-primary'][100],
                'inverse-primary-disabled': colors.black[30],
                'inverse-secondary-hover': colors.white,
                'inverse-secondary-focused': colors['brand-primary'][100],
                'inverse-secondary-disabled': colors.black[30],
                'inverse-secondary-pressed': colors.success[100],
                'inverse-icon-hover': colors['brand-primary'][100],
                'inverse-icon-disabled': colors.black[30],
            },
            background: {
                'primary-hover': colors.null,
                'primary-pressed': colors['brand-secondary'][100],
                'secondary-hover': colors['brand-primary'][100],
                'secondary-focused': colors.null,
                'secondary-pressed': colors['brand-secondary'][100],
                'inverse-primary-hover': colors['brand-primary'][100],
                'inverse-primary-disabled': colors.black[20],
                'inverse-primary-pressed': colors['brand-secondary'][100],
                'inverse-secondary-hover': colors['brand-primary'][100],
                'inverse-secondary-disabled': colors.black[20],
                'inverse-secondary-pressed': colors.null,
            },
            border: {
                'primary-hover': colors['brand-primary'][100],
                'secondary-default': colors['brand-primary'][100],
                'secondary-disabled': colors.black[20],
                'secondary-pressed': colors.null,
                'inverse-primary-focused': colors['brand-secondary'][60],
                'inverse-secondary-focused': colors['brand-secondary'][60],
                'inverse-secondary-disabled': colors.null,
                'inverse-secondary-pressed': colors.success[100],
            },
        },
        label: {
            text: {
                primary: colors.white,
                secondary: colors['brand-primary'][100],
                success: colors.success[100],
                danger: colors.danger[100],
                disable: colors.black[60],
            },
            background: {
                primary: colors['brand-primary'][100],
                secondary: colors['brand-primary'][60],
                success: colors.success[60],
                danger: colors.danger[60],
                disable: colors.black[30],
            },
        },
        icons: {
            background: {
                disable: colors.black[30],
            },
        },
    },
}

export {borders, colors, radius, shadows, spacing, iconsSize, semanticOverrides, fontWeights}
